import gql from 'graphql-tag';

const CREATE_INVOICE_TEMPLATE = gql`
  mutation createInvoiceTemplate($input: CreateInvoiceTemplateInput!) {
    createInvoiceTemplate(input: $input) {
      templateId
      title
      memo
      footer
      layoutConfiguration
    }
  }
`;

const UPDATE_INVOICE_TEMPLATE = gql`
  mutation updateInvoiceTemplate($input: UpdateInvoiceTemplateInput!) {
    updateInvoiceTemplate(input: $input) {
      templateId
      title
      memo
      footer
      layoutConfiguration
    }
  }
`;

const UPDATE_QUOTE_TEMPLATE = gql`
  mutation updateQuoteTemplate($input: UpdateQuoteTemplateInput!) {
    updateQuoteTemplate(input: $input) {
      templateId
      title
      memo
      footer
      layoutConfiguration
    }
  }
`;

const CREATE_QUOTE_TEMPLATE = gql`
  mutation createQuoteTemplate($input: CreateQuoteTemplateInput!) {
    createQuoteTemplate(input: $input) {
      templateId
      title
      memo
      footer
      layoutConfiguration
    }
  }
`;

export {
  CREATE_INVOICE_TEMPLATE,
  UPDATE_INVOICE_TEMPLATE,
  UPDATE_QUOTE_TEMPLATE,
  CREATE_QUOTE_TEMPLATE
};
